import * as R from 'ramda'
import {
  createReducer,
  updateObject,
  updateItemInArray,
  createNamedReducer,
} from 'helpers/ReducerUtil'
import {
  CHANGE_SELECT,
} from './constants'
import {
  TRUE,
  FALSE,
} from 'components/custom/FeatureButton/constants'

const isSameAs = (value) => R.complement(R.propEq('value', value))
/*
 * whenever you change value add to values
 */
const changeSelection = (values, action) => {
  let newValues
  const { featureObj: { label, ...feature } } = action
  if (label === FALSE) {
     newValues = [...values, feature]
  } else {
    newValues = R.filter(isSameAs(feature.value))(values)
  }
  return newValues
}

const featureReducer = createReducer([], {
  [CHANGE_SELECT]: changeSelection,
})

export default featureReducer
